import { useEffect } from 'react';

import SegmentConfig from '../../constants/segmentConfig';
import useAnalytics from '../useAnalytics';

const SUCCESS_STATUS = 'success';

const usePendingListTracking = ({ status, trades }) => {
  const track = useAnalytics();

  useEffect(() => {
    if (status === SUCCESS_STATUS && trades?.length && track) {
      track(SegmentConfig.names.loadListOfTrades, {
        // required properties, but not relevant for Pending list
        list_sort_option_value: 'N/A',
        sc_sale_event_view_type: null,
        vehicle_cards_view_type: null
      });
    }
  }, [trades, status, track]);
};

export default usePendingListTracking;
